import React from 'react';
import { Button, Modal } from 'antd';
import { InfoModalSize } from 'components/ui/info-modal/types';

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  children?: React.ReactNode;
  okText?: string;
  isDisabled?: boolean;
  subTitle?: string;
  size?: InfoModalSize;
}

const widthBySize: Record<InfoModalSize, number> = {
  small: 500,
  medium: 800,
  large: 1200,
};

const InfoModal: React.FC<InfoModalProps> = ({
  title,
  isOpen,
  onClose,
  onConfirm,
  okText,
  children,
  isDisabled = false,
  subTitle,
  size = 'small',
}) => {
  return (
    <Modal
      title={<div className="text-2xl font-medium">{title}</div>}
      width={widthBySize[size]}
      open={isOpen}
      classNames={{
        header: 'text-lg font-bold',
      }}
      onCancel={onClose}
      footer={[
        <Button
          key="ok"
          type="primary"
          onClick={onConfirm}
          disabled={isDisabled}
        >
          {okText}
        </Button>,
      ]}
    >
      <div className="w-full border-y py-3 text-[#5E6B7C]">
        {subTitle && (
          <div className="text-sm text-[#5E6B7C] mb-3">{subTitle}</div>
        )}

        {children}
      </div>
    </Modal>
  );
};

export default InfoModal;
